const Links = () => {

    const allEmptyLinks         = document.querySelectorAll('a[href="#"]');
    const allNotEmptyLinks      = document.querySelectorAll('a[href^="#"]');

    // Do nothing if link is empty url
    if(allEmptyLinks) {
        allEmptyLinks.forEach(link => {
            link.addEventListener('click', function(event) {
                event.preventDefault();
            });
        });
    }

    // Scroll smoothly to element with ID
    if (allNotEmptyLinks) {
        allNotEmptyLinks.forEach(anchor => {
            anchor.addEventListener('click', function (event) {
                event.preventDefault();

                const targetId = this.getAttribute('href');
                if (targetId && targetId.startsWith('#') && targetId.length > 1) {
                    const targetElement = document.querySelector(targetId);
                    console.log(targetElement)
                    if (targetElement) {
                        const yOffset = -100; // top offset
                        const yPosition = targetElement.getBoundingClientRect().top + window.pageYOffset + yOffset;

                        window.scrollTo({
                            top: yPosition,
                            behavior: 'smooth'
                        });
                    }
                }
            });
        });
    }

}

export default Links;